module.exports = __webpack_public_path__ + "img/5.8.TSS.4971b222.png";